import React from "react";
import TagItem from "./TagItem";

interface TagListProps {
  items: string[];
  onRemove: (index: number) => void;
}

const TagList: React.FC<TagListProps> = ({ items, onRemove }) => {
  if (!items || items.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {items.map((item, index) => (
        <TagItem key={index} item={item} index={index} onRemove={onRemove} />
      ))}
    </div>
  );
};

export default TagList;
